module.exports = __webpack_public_path__ + "static/media/instagram_logo.67ef6932.png";